import {
  Box,
  Center,
  Flex,
  HStack,
  Image,
  useBreakpointValue,
  useToast
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import DashboardHeader from "../../../components/common/DashboardHeader";
import BasicDetails from "../../../components/trainee/register/BasicDetails";
import Certification from "../../../components/trainee/register/Certification";
import EducationProfile from "../../../components/trainee/register/EducationProfile";
import KitSize from "../../../components/trainee/register/KitSize";
import RegisterLine from "../../../components/trainee/register/RegisterLine";
import rarrow from "../../../img/rarrow.svg";

import { BreadCrumbs } from "../../../components/common/BreadCrumb";

const Register = () => {
  const navigate = useNavigate();

  const [pageState, setPagestate] = useState(0);
  const toast = useToast();

  const [courseTitle, setCourseTitle] = useState<string>();

  const isMobile = useBreakpointValue({ base: true, md: false, lg: false });

  const pages = [
    { index: 1, component: BasicDetails },
    { index: 2, component: EducationProfile },
    { index: 3, component: Certification },
    { index: 4, component: KitSize },
  ];

  const switchPage = () => {
    const Component = pages[pageState].component;

    return <Component nextPage={nextPage} prePage={prePage} />;
  };

  const nextPage: any = () => {
    if (pageState < pages.length) {
      const pg = pageState;
      setPagestate(pg + 1);
    }
    localStorage.setItem("page_no", pageState.toString());
  };

  const prePage = () => {
    if (pageState > 0) {
      const pg = pageState;
      setPagestate(pg - 1);
    }
    localStorage.setItem("page_no", pageState.toString());
  };

  useEffect(() => {
    const pageNo = localStorage.getItem("page_no") ?? "0";

    setPagestate(parseInt(pageNo));
  }, []);

  const clearCourseFromLocalStorage = () => {
    window.location.reload();
  };

  type BreadCrumbItems = {
    breadCrumbText: string;
    breadCrumbPath: string;
  };

  const breadcrumbItems: BreadCrumbItems[] = [
    {
      breadCrumbText: "Basic Details",
      breadCrumbPath: "/basic-details",
    },
    {
      breadCrumbText: "Education Profile",
      breadCrumbPath: "/education",
    },
    {
      breadCrumbText: "Certification",
      breadCrumbPath: "/certificate",
    },
    {
      breadCrumbText: "Kit size",
      breadCrumbPath: "/kit-size",
    },
  ];

  return (
    <>
      <DashboardHeader />
      <Flex
        justifyContent="center"
        bg="#F9F8F8"
        height="100%"
        bgSize="cover"
        minHeight="100vh"
        flexDirection={"column"}
        width={"100%"}
      >
        {isMobile && (
          <Box width={"100%"} marginTop={"3rem"}>
            <BreadCrumbs
              breadCrumbItems={breadcrumbItems}
              breadCrumbActiveItem={breadcrumbItems[pageState].breadCrumbText}
            />
          </Box>
        )}

        <Center
          mt={["35px", "35px", "40px", "40px"]}
          width="100%"
          justifyContent="center"
          alignContent={"center"}
          flexDirection={"column"}
        >
          <Box
            display={{ lg: "block", md: "block", sm: "none", base: "none" }}
            height="3.5rem"
            width={{ lg: "65%", md: "60%", sm: "90%", base: "90%" }}
            bg="white"
            boxShadow="0px 0px 4px rgba(0, 0, 0, 0.08)"
            px={["0px", "0px", "2rem", "4rem"]}
            py={2}
          >
            <HStack justifyContent="space-between" alignItems={"center"} height={"100%"}>
              <RegisterLine
                position="1"
                title="Basic details"
                bgColor={pageState === 0 ? "brand.2" : "brand.1"}
                textColor={pageState === 0 ? "#EC3337" : "brand.subtitle"}
                fontWeight={pageState === 0 ? "700" : "400"}
              />

              <Image src={rarrow} />

              <RegisterLine
                position="2"
                title="Education profile"
                bgColor={pageState === 1 ? "brand.2" : "brand.1"}
                textColor={pageState === 1 ? "#EC3337" : "brand.subtitle"}
                fontWeight={pageState === 1 ? "700" : "400"}
              />

              <Image src={rarrow} />

              <RegisterLine
                position="3"
                title="Certification"
                bgColor={pageState === 2 ? "brand.2" : "brand.1"}
                textColor={pageState === 2 ? "#EC3337" : "brand.subtitle"}
                fontWeight={pageState === 2 ? "700" : "400"}
              />

              <Image src={rarrow} />

              <RegisterLine
                position="4"
                title="Kit Size"
                bgColor={pageState === 3 ? "brand.2" : "brand.1"}
                textColor={pageState === 3 ? "#EC3337" : "brand.subtitle"}
                fontWeight={pageState === 3 ? "700" : "400"}
              />
            </HStack>
          </Box>

          <Box
            boxShadow="base"
            // width="764px"
            width={{ lg: "65%", md: "60%", sm: "90%", base: "90%" }}
            bg="white"
            mb="50px"
            mt={6}
            py={4}
            px={8}
          >
            {switchPage()}

            <Flex justifyContent="space-between" mt={6} px={6}>
              {/* {
                                pageState >= 1 ?
                                    <Button onClick={prePage} colorScheme="white" color='red' size="sm" fontSize={11} borderRadius={10} px={10}>PREVIOUS</Button> : <Box></Box>
                            } */}

              {/* {
                                pageState >= 0 && pageState <3 ?
                                    <Button onClick={nextPage} py='13px' px='30px'  type="submit" fontSize={11} borderRadius={0} colorScheme='red' size='sm'>NEXT</Button> : 
                                      <Button py='13px' px='30px'  type="submit" fontSize={11} borderRadius={0} colorScheme='red' size='sm' onClick={() => navigate(routes.Dashboard)}>SUBMIT</Button>
                            } */}
            </Flex>
          </Box>
        </Center>
      </Flex>
    </>
  );
};

export default Register;
